/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

import { Logger } from '@quickplay/foundation';
import { PALSession } from './PALSession';
import { PALSessionImpl } from './internal/PALSessionImpl';
import { CastPALSessionImpl } from './internal/CastPalSessionImpl';

/**
 * Creates a new PAL session.
 * @param allowStorage whether PAL has purpose 1 consent to use identifiers and storage. The value needs to be
 * determined by integrating with CMP (Consent Management Provider). This is set to false by default. If specified
 * as true, PAL has consent from the user to use information like cookies, device IDs and advertising IDs. This
 * value needs to be set to be IAB TCFv2 (Transparency and Consent Framework) compliant.
 * @param logger
 */
export function createPalSession(allowStorage: boolean, logger?: Logger): PALSession {
  return new PALSessionImpl(allowStorage, logger);
}

/**
 * Creates a new Cast PAL session. Specific to Chromecast.
 * @param allowStorage whether PAL has purpose 1 consent to use identifiers and storage. The value needs to be
 * determined by integrating with CMP (Consent Management Provider). This is set to false by default. If specified
 * as true, PAL has consent from the user to use information like cookies, device IDs and advertising IDs. This
 * value needs to be set to be IAB TCFv2 (Transparency and Consent Framework) compliant.
 * @param logger
 */
export function createCastPALSession(allowStorage: boolean, logger?: Logger): PALSession {
  return new CastPALSessionImpl(allowStorage, logger);
}
